import { GameIcon } from "../assets/gameIcons.js";
import { pick, useT } from "../i18n/index.js";
import { Link } from "../router.js";
import { Timer, useServerTick } from "../ui/Timer.js";
import { useEvents } from "./state.js";
import { eventDestination, orderedEventRuns } from "./presentation.js";
import { PromoArt } from "../store/PromoArt.js";
import { HuntChip } from "../world/HuntChip.js";
import { useAlliance } from "../alliance/state.js";
import { formatCompact } from "../ui/Counter.js";

/** The HUD's "today" strip on the base: active events with countdowns and the claimable count (R68). */
export function TodayStrip() {
  const t = useT();
  const runs = useEvents((s) => s.runs);
  const daily = useEvents((s) => s.daily);
  const duel = useAlliance((s) => s.duel);
  const now = useServerTick(1);
  if (!runs) return null;
  const visible = orderedEventRuns(runs.filter(r => r.category !== "daily" && r.startsAt <= now && r.endsAt > now), now).slice(0, 1);
  const claimable = (daily?.login.claimable ? 1 : 0) + (daily?.login.day28.claimable ? 1 : 0)
    + (daily?.activity.chests.filter(c => c.claimable).length ?? 0)
    + (daily?.missions.filter(m => m.done && !m.claimed).length ?? 0);
  return (
    <div className="today-strip reward-dock" data-testid="today-strip">
      <Link to="/app/events/daily" className={`today-chip glass reward-action ${claimable > 0 ? "hot" : ""}`} data-testid="daily-reward-entry">
        <PromoArt id="supply-drop" className="dock-backdrop" />
        <GameIcon id="itm.chest_gold" size={72} />
        <span className="reward-action-copy"><small>{claimable > 0 ? pick({ de: "ABHOLBEREIT", en: "READY TO CLAIM" }) : t("events.today")}</small><strong>{pick({ de: "Belohnungen", en: "Rewards" })}</strong>
        <span>{claimable > 0 ? pick({ de: `${claimable} verfügbar`, en: `${claimable} available` }) : pick({ de: "Aufträge ansehen", en: "View missions" })}</span></span>
      </Link>
      {duel && !duel.settled && duel.endsAt > now ? (
        <Link to="/app/alliance/events" className="today-chip glass event-action" data-testid="today-duel">
          <PromoArt id="event-frontier" className="dock-backdrop" />
          <GameIcon id="emote.shield" size={64} />
          <span className="reward-action-copy"><small>{pick({ de: "ALLIANZ-DUELL", en: "ALLIANCE DUEL" })}</small><strong className="mono" data-testid="today-duel-score">{duel.me.tag} {formatCompact(duel.me.score)} : {duel.opponent ? `${formatCompact(duel.opponent.score)} ${duel.opponent.tag}` : `${formatCompact(duel.target)} ${pick({ de: "Ziel", en: "target" })}`}</strong><span className="mono"><Timer finishesAt={duel.endsAt} /></span></span>
        </Link>
      ) : null}
      {visible.map((r) => r.defId === "ev.hourly_hunt" ? <HuntChip key={r.runId} variant="card" /> : (
        <Link key={r.runId} to={eventDestination(r)} className={`today-chip glass event-action ${r.milestones.some((m) => m.claimable) ? "hot" : ""}`}>
          <PromoArt id="event-frontier" className="dock-backdrop" />
          <GameIcon id={r.icon} size={64} />
          <span className="reward-action-copy"><small>{pick({ de: "EVENT LÄUFT", en: "EVENT LIVE" })}</small><strong>{pick(r.name)}</strong><span className="mono"><Timer finishesAt={r.endsAt} /></span></span>
        </Link>
      ))}
    </div>
  );
}
